import { AddNewController, EditController } from "../../../list-management/scripts/list-management.controllers";
import { Section } from "../../../list-management/scripts/list-management.form-sections";
import { JsonItem, UserRequestExtended, UpdateGroupRequest, PickListItem, AppUserExtended, AppUserGroupCommittee, UpdateUserRequest, AppUserRedacted } from "../../../list-management/scripts/list-management.objects";
import { getDisplayDate } from "../../../../shared/scripts/date-functions"
import _ from "lodash";

declare var $: any;

export class UpdateUserRequestController {
    id: string;
    title: string;
    submitHandler: string; // ?handler={this}
    sections: Section[];
    modalIdTarget: string;
    displayPropertyName: string;
    requestRoute: string // = /secure/.../.../endpoint

    editController: EditController;

    constructor(id: string, title: string, submitHandlerName: string, sections: Section[], modalIdTarget: string, displayPropertyName: string, requestRoute: string) {
        this.id = id;
        this.title = title;
        this.submitHandler = submitHandlerName;
        this.sections = sections;
        this.modalIdTarget = modalIdTarget;
        this.displayPropertyName = displayPropertyName;
        this.requestRoute = requestRoute;

        this.editController = new EditController(this.id, this.title, this.submitHandler, this.sections, this.modalIdTarget, this.displayPropertyName);
    }

    initialize(pickLists: JsonItem[], selectedItems: any[], selectedSectionId: string): void {
        this.editController.initialize(pickLists, selectedItems, selectedSectionId);

        // Update Modal Footer Button
        let modalContentTarget = $(`#${this.modalIdTarget}`);
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.saveRequestModal()">Send Update Request</button><span class="error-msg ml-5" id="request-footer-error"></span>`;
        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    async save(): Promise<any> {
        if (this.editController.selectedSection.fields.some(field => field.specialCaseEntity != undefined)) {
            this.editController.updateChangeLog();
        }

        let requestType = 0;
        if (this.editController.selectedSection.id == "pm-update-user-group-request-section") {
            requestType = 2;
        }
        else if (this.editController.selectedSection.id == "pm-deactivate-user-request-section") {
            requestType = 3;
        }

        if (requestType == 0) {
            return;
        }

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `${this.requestRoute}?handler=${this.submitHandler}`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(this.editController.updatedItems), requestType: requestType },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    showLoading(isLoading: boolean) {
        if (isLoading) {
            this.showSaved(false);
            $("#edit-item-content").addClass("d-none");
            $("#request-item-saving").removeClass("d-none");
        }
        else {
            $("#edit-item-content").removeClass("d-none");
            $("#request-item-saving").addClass("d-none");
        }
    }

    showSaved(isSaved: boolean) {
        if (isSaved) {
            $("#request-save-complete-block").removeClass("d-none");
            $("#request-save-in-progress-block").addClass("d-none");
        }
        else {
            $("#request-save-complete-block").addClass("d-none");
            $("#request-save-in-progress-block").removeClass("d-none");
        }
    }

    validateChanged(): boolean {
        let notChangedMessage = "";

        this.editController.selectedSection.fields.forEach(field => {
            if (!field.checkChanged()) {
                notChangedMessage = "Please update the user's information prior to sending the request."
            }
        });

        let errorMsgTarget = $("#request-footer-error")
        errorMsgTarget.text(notChangedMessage);

        if (notChangedMessage == "") {
            return true;
        }
        else {
            return false;
        }
    }
}

export class ViewUserRequestController {
    modalId: string;
    allUserRequests: UserRequestExtended[];
    pickLists: JsonItem[];

    viewRequestModal: JQuery<HTMLElement>;

    constructor(modalId: string, allUserRequests: UserRequestExtended[], pickLists: JsonItem[]) {
        this.modalId = modalId;
        this.viewRequestModal = $(`#${modalId}`);

        this.allUserRequests = allUserRequests;
        this.pickLists = pickLists;
    }

    openModal(requestId: number): void {
        this.initializeModal(requestId);
        this.viewRequestModal.modal('show');
    }

    initializeModal(requestId: number): void {
        let html = ''

        let foundRequest = this.allUserRequests.find(request => request.UserRequest.Id == requestId);
        if (foundRequest) {
            // Title / Request Type
            let title = "";
            let description = "";
            if (foundRequest.UserRequest.TypeId == 1) {
                title = "Add User Request";
                description = "Create an account for the user, and grant them access to the ReVAMPP private portal."
            }
            else if (foundRequest.UserRequest.TypeId == 2) {
                title = "Update User Group Request";
                description = "Update the user's group membership. Group membership changes shown below.";
            }
            else if (foundRequest.UserRequest.TypeId == 3) {
                title = "Deactivate User Request";
                description = "Deactivate the user, removing their access from the ReVAMPP private portal."
            }

            // Status
            let statusBlock = `<div class="revampp-unknown-block">Unknown</div>`
            if (foundRequest.UserRequest.StatusId == 1) {
                statusBlock = `<div class="revampp-review-block">PM Review</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 2) {
                statusBlock = `<div class="revampp-inactive-block">CDSC Review</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 3) {
                statusBlock = `<div class="revampp-active-block">Completed</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 4) {
                statusBlock = `<div class="revampp-hidden-block">PM Disapproved</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 5) {
                statusBlock = `<div class="revampp-hidden-block">CDSC Disapproved</div>`
            }

            let titleStatusContainer = `
                <div class="d-flex justify-content-start align-items-center">
                    <div class="modal-title mb-0">${title}</div>
                    <div class="pl-3 font-size12">${statusBlock}</div>
                </div>
            `

            // User Information
            let userInfoContainer = `
                <div class="mt-3">
                    <span class='font-weight-600'>For User: </span>${foundRequest.UpdateUserRequest.FirstName} ${foundRequest.UpdateUserRequest.LastName} (${foundRequest.UpdateUserRequest.Email})
                </div>
            `;

            // Request Date
            let requestDateString = getDisplayDate(foundRequest.UserRequest.CreateDate);
            let requestDateContainer = `
                <div class="mt-1">
                    <span class='font-weight-600'>Request Date: </span>${requestDateString}
                </div>
            `

            // Center
            let requestCenterArr: string[] = foundRequest.UserRequest.RequestCenterIds.split("|");
            let requestCenterStrArr = [];
            let centerPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-center")?.Json;
            let requestCenterContainer = "";
            if (centerPickList) {
                requestCenterArr.forEach(centerId => {
                    let foundCenter = centerPickList.find(center => center.Id.toString() == centerId);
                    if (foundCenter) {
                        requestCenterStrArr.push(foundCenter.Value);
                    }
                });
                requestCenterStrArr.sort();
                requestCenterContainer = `
                    <div class="mt-1">
                        <span class='font-weight-600'>Center: </span>${requestCenterStrArr.join(", ")}
                    </div>
                `
            }

            

            // Update User Group Request
            let groupRequestContainer = ``;
            if (foundRequest.UserRequest.TypeId == 2) {
                let addRequests = foundRequest.UpdateGroupRequestList.filter(request => request.IsNew);
                let removeRequests = foundRequest.UpdateGroupRequestList.filter(request => !request.IsNew);

                let addRequestContainer = "";
                if (addRequests.length > 0) {
                    addRequestContainer = `
                    <div class="mt-2">
                        <div class="font-weight-600"><i class="fa-solid fa-circle-plus add-icon pr-2"></i>Add to Groups:</div>
                        <div class="mt-1">
                            ${this.createGroupList(addRequests)}
                        </div>
                    </div>
                    `
                }

                let removeRequestContainer = "";
                if (removeRequests.length > 0) {
                    removeRequestContainer = `
                    <div class="mt-2">
                        <div class="font-weight-600"><i class="fa-solid fa-circle-minus remove-icon pr-2"></i>Remove from Groups:</div>
                        <div class="mt-1">
                            ${this.createGroupList(removeRequests)}
                        </div>
                    </div>
                    `
                }

                groupRequestContainer = `
                    <div class="mt-0">
                        ${addRequestContainer}
                        ${removeRequestContainer}
                    </div>
                `
            }

            html = `
                ${titleStatusContainer}
                ${userInfoContainer}
                ${requestDateContainer}
                ${requestCenterContainer}
                <div class="mt-2">
                    <p class="mb-0">${description}</p>
                </div>
                ${groupRequestContainer}
            `;
        }

        this.viewRequestModal.find(".view-request-container").empty().html(html);
    }


    createGroupList(request: UpdateGroupRequest[]): string {
        let groupListHtml = "";
        let groupNameList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-groups").Json;
        let groupRoleList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-group-roles").Json;

        for (let i = 0; i < request.length; i++) {
            let currentGroup: UpdateGroupRequest = request[i];

            let groupName = "";
            let foundGroup = groupNameList.find(item => item.Id == currentGroup.GroupId);
            if (foundGroup) {
                groupName = foundGroup.Value;
            }

            let roleName = "";
            let foundRole = groupRoleList.find(item => item.Id == currentGroup.GroupRoleId);
            if (foundRole) {
                roleName = foundRole.Value;
            }

            groupListHtml += `<li class='mb-1'>${groupName} - ${roleName}</li>`;
        }

        return `<ul class="mb-0">${groupListHtml}</ul>`;
    }
}

export class ReviewRequestController {
    id: string;
    title: string;
    submitHandler: string; // ?handler={this}
    sections: Section[];
    modalIdTarget: string;
    displayPropertyName: string;

    editController: EditController;
    currentRequest: UserRequestExtended = null;

    userRequestList: UserRequestExtended[] = [];
    pickLists: JsonItem[] = [];

    constructor(id: string, title: string, submitHandlerName: string, sections: Section[], modalIdTarget: string, displayPropertyName: string) {
        this.id = id;
        this.title = title;
        this.submitHandler = submitHandlerName;
        this.sections = sections;
        this.modalIdTarget = modalIdTarget;
        this.displayPropertyName = displayPropertyName;

        this.editController = new EditController(this.id, this.title, this.submitHandler, this.sections, this.modalIdTarget, this.displayPropertyName);
    }

    updateStoredLists(userRequestList: UserRequestExtended[], pickLists: JsonItem[]) {
        this.userRequestList = userRequestList;
        this.pickLists = pickLists;
    }

    initialize(foundRequest: UserRequestExtended): void {
        let selectedItems: AppUserExtended[] = [];
        let selectedSectionId = "";
        let updatedUser: AppUserExtended = _.cloneDeep(foundRequest.AppUserExtended);
        // If this is an update user request
        if (updatedUser) {
            // Update User Groups
            if (foundRequest.UserRequest.TypeId == 2) {
                selectedSectionId = "user-review-revampp-user-groups";
                let updatedGroups: AppUserGroupCommittee[] = updatedUser.AppUserGroupList;
                foundRequest.UpdateGroupRequestList.forEach(group => {
                    let foundIndex = updatedGroups.findIndex(foundGroup => group.GroupId == foundGroup.GroupId && group.GroupRoleId == foundGroup.GroupRoleId);
                    if (group.IsNew) {
                        // Check to make sure the new group hasn't already been added
                        if (foundIndex < 0) {
                            let addGroup: AppUserGroupCommittee = {
                                GroupId: group.GroupId,
                                GroupRoleId: group.GroupRoleId,
                                AppUserId: group.AppUserId,
                                Id: 0
                            }
                            updatedGroups.push(addGroup);
                        }
                    }
                    else {
                        if (foundIndex >= 0) {
                            updatedGroups.splice(foundIndex, 1);
                        }
                    }
                })
                updatedUser.AppUserGroupList = updatedGroups;
            }
            // Deactivate User Request
            else if (foundRequest.UserRequest.TypeId == 3) {
                selectedSectionId = "user-review-revampp-user-permissions"
                updatedUser.AppUser.IsActive = false;
                updatedUser.AppUser.IsVisible = false;
            }

            selectedItems.push(updatedUser);
        }  

        this.editController.initialize(this.pickLists, selectedItems, selectedSectionId);

        // Revise "list management" edit modal for review version (add description, move title)
        this.updateModalDisplay(foundRequest);
    }

    openModal(requestId: number): void {
        let foundRequest: UserRequestExtended = this.userRequestList.find(request => request.UserRequest.Id == requestId);
        if (foundRequest) {
            this.initialize(foundRequest);
            this.currentRequest = foundRequest;
        }
        else {
            this.currentRequest = null;
        }
        $(`#${this.modalIdTarget}`).modal('show');
    }

    updateModalDisplay(foundRequest: UserRequestExtended): void {
        let modalContentTarget = $(`#${this.modalIdTarget}`);

        // Remove the previous title, since we have a new one in the description
        modalContentTarget.find(".modal-title").remove();

        let modalDescriptionContainer = modalContentTarget.find(".review-request-description-container");
        let modalDescription = this.createDescriptionBlock(foundRequest);
        modalDescriptionContainer.empty().html(modalDescription);

        if (foundRequest.UserRequest.TypeId == 2) {
            // Remove description/label from edit block
            modalContentTarget.find(".group-selector-label").empty().html(`<label>Updated User Groups</label>`)
            modalContentTarget.find(".group-selector-description").text("Below are the user's group after the updates have been applied. You can make additional updates to the user's group list if necessary.")
        }
        else if (foundRequest.UserRequest.TypeId == 3) {
            modalContentTarget.find(".edit-modal-section-block").prepend(`<p>Below are the user access properties after the updates have been applied. To properly deactivate the user both properties should be set to 'No'.</p>`)
        }

        let htmlFooterContent = "";
        if (foundRequest.UserRequest.TypeId == 2 || foundRequest.UserRequest.TypeId == 3) {
            htmlFooterContent = `
            <div class="row">
                <button class="greenbtn mr-4 col-12 col-md-auto mb-2" type="button" onclick="page.saveApprovedRequest()">Approve and Complete Request</button>
                <button class="redbtn col-12 col-md-auto mb-2" type="button" onclick="page.saveDenyRequest()">Deny/Reject Request</button>
            </div>`;
        }
        
        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    createDescriptionBlock(foundRequest: UserRequestExtended): string {
        let html = "";

        // Title / Request Type
        let title = "";
        let description = "";
        if (foundRequest.UserRequest.TypeId == 2) {
            title = "Update User Group Request";
            description = "Approving/Completing this request will update the user groups with the updates shown below. Prior to completing the request, please review the information and ensure the user has the correct permissions and access.";
        }
        else if (foundRequest.UserRequest.TypeId == 3) {
            title = "Deactivate User Request";
            description = "Approving/Completing this request will deactivate the user, and remove their visibility across the portal. Prior to completing this request, please review the information and ensure that the user has also been removed from any Teams Channels."
        }

        // Status
        let statusBlock = `<div class="revampp-unknown-block">Unknown</div>`
        if (foundRequest.UserRequest.StatusId == 1) {
            statusBlock = `<div class="revampp-review-block">PM Review</div>`
        }
        else if (foundRequest.UserRequest.StatusId == 2) {
            statusBlock = `<div class="revampp-inactive-block">CDSC Review</div>`
        }
        else if (foundRequest.UserRequest.StatusId == 3) {
            statusBlock = `<div class="revampp-active-block">Completed</div>`
        }
        else if (foundRequest.UserRequest.StatusId == 4) {
            statusBlock = `<div class="revampp-hidden-block">PM Disapproved</div>`
        }
        else if (foundRequest.UserRequest.StatusId == 5) {
            statusBlock = `<div class="revampp-hidden-block">CDSC Disapproved</div>`
        }

        // Request Date
        let requestDateString = getDisplayDate(foundRequest.UserRequest.CreateDate);
        let requestDateContainer = `
            <div class="ml-auto">
                <span class='font-weight-600'>Request Date: </span>${requestDateString}
            </div>
        `;

        let titleStatusContainer = `
                <div class="d-flex justify-content-start align-items-center">
                    <div class="modal-title mb-0">${title}</div>
                    <div class="pl-3 font-size12">${statusBlock}</div>
                    ${requestDateContainer}
                </div>
            `

        // User Information
        let userInfoContainer = `
            <div class="mt-3">
                <span class='font-weight-600'>For User: </span>${foundRequest.UpdateUserRequest.FirstName} ${foundRequest.UpdateUserRequest.LastName} (${foundRequest.UpdateUserRequest.Email})
            </div>
        `;

        // Update User Group Request
        let groupRequestContainer = ``;
        if (foundRequest.UserRequest.TypeId == 2) {
            let addRequests = foundRequest.UpdateGroupRequestList.filter(request => request.IsNew);
            let removeRequests = foundRequest.UpdateGroupRequestList.filter(request => !request.IsNew);

            let addRequestContainer = "";
            if (addRequests.length > 0) {
                addRequestContainer = `
                    <div class="mr-5">
                        <div class="font-weight-600"><i class="fa-solid fa-circle-plus add-icon pr-2"></i>Add to Groups:</div>
                        <div class="mt-1">
                            ${this.createGroupList(addRequests)}
                        </div>
                    </div>
                    `
            }

            let removeRequestContainer = "";
            if (removeRequests.length > 0) {
                removeRequestContainer = `
                    <div class="mr-5">
                        <div class="font-weight-600"><i class="fa-solid fa-circle-minus remove-icon pr-2"></i>Remove from Groups:</div>
                        <div class="mt-1">
                            ${this.createGroupList(removeRequests)}
                        </div>
                    </div>
                    `
            }

            groupRequestContainer = `
                    <div class="mt-2 d-flex">
                        ${addRequestContainer}
                        ${removeRequestContainer}
                    </div>
                `
        }

        html = `
            ${titleStatusContainer}
            ${userInfoContainer}
            <div class="mt-2">
                <p class="mb-0">${description}</p>
            </div>
            ${groupRequestContainer}
        `;

        return html;
    }

    createGroupList(request: UpdateGroupRequest[]): string {
        let groupListHtml = "";
        let groupNameList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-groups").Json;
        let groupRoleList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-group-roles").Json;

        for (let i = 0; i < request.length; i++) {
            let currentGroup: UpdateGroupRequest = request[i];

            let groupName = "";
            let foundGroup = groupNameList.find(item => item.Id == currentGroup.GroupId);
            if (foundGroup) {
                groupName = foundGroup.Value;
            }

            let roleName = "";
            let foundRole = groupRoleList.find(item => item.Id == currentGroup.GroupRoleId);
            if (foundRole) {
                roleName = foundRole.Value;
            }

            groupListHtml += `<li class='mb-1'>${groupName} - ${roleName}</li>`;
        }

        return `<ul class="mb-0">${groupListHtml}</ul>`;
    }

    showLoading(isLoading: boolean) {
        let modal = $(`#${this.modalIdTarget}`);
        if (isLoading) {
            this.showSaved(false);
            modal.find("#edit-item-content").addClass("d-none");
            modal.find("#edit-item-saving").removeClass("d-none");
        }
        else {
            modal.find("#edit-item-content").removeClass("d-none");
            modal.find("#edit-item-saving").addClass("d-none");
        }
    }

    showSaved(isSaved: boolean) {
        let modal = $(`#${this.modalIdTarget}`);
        if (isSaved) {
            modal.find("#edit-save-complete-block").removeClass("d-none");
            modal.find("#edit-save-in-progress-block").addClass("d-none");
        }
        else {
            modal.find("#edit-save-complete-block").addClass("d-none");
            modal.find("#edit-save-in-progress-block").removeClass("d-none");
        }
    }
}

export class NewAddRequestController {
    id: string;
    title: string;
    sections: Section[];
    modalIdTarget: string;

    addController: AddNewController;
    currentRequest: UserRequestExtended = null;

    userRequestList: UserRequestExtended[] = [];
    pickLists: JsonItem[] = [];

    constructor(id: string, title: string, sections: Section[], modalIdTarget: string) {
        this.id = id;
        this.title = title;
        this.sections = sections;
        this.modalIdTarget = modalIdTarget;

        this.addController = new AddNewController(this.id, this.title, "", this.sections, this.modalIdTarget);
    }

    updateStoredLists(userRequestList: UserRequestExtended[], pickLists: JsonItem[]) {
        this.userRequestList = userRequestList;
        this.pickLists = pickLists;
    }

    initialize(foundRequest: UserRequestExtended = null): void {
        if (foundRequest != null) {
            let request = _.cloneDeep(foundRequest);
            let createdUser = AppUserExtended.createFromRequest(request);

            this.addController.initialize(this.pickLists, createdUser);
        }
        else {
            let newUser = new AppUserExtended();
            this.addController.initialize(this.pickLists, newUser);
        }
        

        // Revise "list management" edit modal for review version (add description, move title)
        this.updateModalDisplay(foundRequest);
    }

    openModal(requestId: number = -99): void {
        // PM Create New User
        if (requestId == -99) {
            this.initialize();
            this.currentRequest = null;
        }
        // Updating Existing Request
        else {
            let foundRequest: UserRequestExtended = this.userRequestList.find(request => request.UserRequest.Id == requestId);
            if (foundRequest) {
                this.initialize(foundRequest);
                this.currentRequest = foundRequest;
            }
            else {
                this.currentRequest = null;
            }
        }
        
        $(`#${this.modalIdTarget}`).modal('show');
    }

    updateModalDisplay(foundRequest: UserRequestExtended): void {
        let modalContentTarget = $(`#${this.modalIdTarget}`);

        // For existing Requests
        if (foundRequest != null) {
            // Update Loading Text 
            if (foundRequest.UserRequest.StatusId == 1) {
                modalContentTarget.find("#save-in-progress-block").text("Sending Request...");
                modalContentTarget.find("#save-complete-block").text("Request Sent!");
            }
            // For CDSC
            else {
                modalContentTarget.find("#save-in-progress-block").text("Updating...");
                modalContentTarget.find("#save-complete-block").text("Request Updated!");
            }

            // Remove the previous title, since we have a new one in the description
            let modalDescription = this.createDescriptionBlock(foundRequest);
            modalContentTarget.find(".modal-title").remove();
            modalContentTarget.find(".modal-body").prepend(modalDescription);
            modalContentTarget.find(".sections-block-container").addClass("md-edit-window");

            let htmlFooterContent = "";
            // Footer for PM Review for New User Requests
            if (foundRequest.UserRequest.StatusId == 1) {
                htmlFooterContent = `
                <div class="row">
                    <button class="greenbtn mr-4 col-12 col-md-auto mb-2" type="button" onclick="page.approveNewUserRequest()">Approve Request</button>
                    <button class="redbtn col-12 col-md-auto mb-2" type="button" onclick="page.denyNewUserRequest()">Deny/Reject Request</button>
                </div>`;
            }
            // Footer for CDSC Review for New User Requests
            else {
                htmlFooterContent = `
                <div id="${this.id}-submit-error" class="d-none text-danger col-12 px-0 mb-1"></div>
                <div class="row">
                    <button class="greenbtn btn-md mr-4 col-12 col-md-auto mb-2" type="button" onclick="page.completeNewUserRequest()"><i class="fa-solid fa-envelope dropdown-icon pr-2"></i> Complete Request & Send Welcome Email</button>
                    <button class="greenbtn btn-md mr-4 col-12 col-md-auto mb-2" type="button" onclick="page.completeNewUserRequest(0)">Complete Request</button>
                    <button class="redbtn btn-md col-12 col-md-auto mb-2" type="button" onclick="page.denyNewUserRequest()">Deny/Reject Request</button>
                </div>`;
            }

            modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
        }
        // For Creating New Users
        else {
            // Update Loading Text
            modalContentTarget.find("#save-in-progress-block").text("Sending Request...");
            modalContentTarget.find("#save-complete-block").text("Request Sent!");

            // Remove the previous title, since we have a new one in the description
            let modalDescription = this.createDescriptionBlock(foundRequest);
            modalContentTarget.find(".modal-title").remove();
            modalContentTarget.find(".modal-body").prepend(modalDescription);
            modalContentTarget.find(".sections-block-container").addClass("md-edit-window");

            let htmlFooterContent = `
                <div class="row">
                    <button class="greenbtn mr-4 col-12 col-md-auto mb-2" type="button" onclick="page.createNewUserRequest()">Send New User Request</button>
                </div>`;
            modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
        }
        
    }

    createDescriptionBlock(foundRequest: UserRequestExtended): string {
        let html = "";

        // Title / Request Type
        let title = "";
        let description = "";
        if (foundRequest != null) {
            if (foundRequest.UserRequest.TypeId == 1) {
                title = "Add New User Request";
                if (foundRequest.UserRequest.StatusId == 1) {
                    description = "Below is the information for the user requesting a new ReVAMPP Account. Please review the information and make any necessary edits. Approving this request will send the request to the CDSC for account creation."
                }
                else {
                    description = "Approving/Completing this request will create a new account for the user, and send them a welcome email. Prior to completing the request, please review the information and ensure that the user has the correct permissions and access."
                }
            }
        }
        else {
            title = "Add New User Request";
            description = "Please complete the form below with the information for the new ReVAMPP user. This request will be sent to the CDSC for account creation."
        }
        

        // Status
        let statusBlock = `<div class="revampp-unknown-block">Unknown</div>`
        if (foundRequest != null) {
            if (foundRequest.UserRequest.StatusId == 1) {
                statusBlock = `<div class="revampp-review-block">PM Review</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 2) {
                statusBlock = `<div class="revampp-inactive-block">CDSC Review</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 3) {
                statusBlock = `<div class="revampp-active-block">Completed</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 4) {
                statusBlock = `<div class="revampp-hidden-block">PM Disapproved</div>`
            }
            else if (foundRequest.UserRequest.StatusId == 5) {
                statusBlock = `<div class="revampp-hidden-block">CDSC Disapproved</div>`
            }
        }
        else {
            statusBlock = "";
        }
        

        // Request Date
        if (foundRequest != null) {
            let requestDateString = getDisplayDate(foundRequest.UserRequest.CreateDate);
            let requestDateContainer = `
                <div class="ml-auto">
                    <span class='font-weight-600'>Request Date: </span>${requestDateString}
                </div>
            `;

            let titleStatusContainer = `
                <div class="d-flex justify-content-start align-items-center">
                    <div class="modal-title mb-0">${title}</div>
                    <div class="pl-3 font-size12">${statusBlock}</div>
                    ${requestDateContainer}
                </div>
            `;

            // User Information
            let userInfoContainer = `
                <div class="mt-3">
                    <span class='font-weight-600'>For User: </span>${foundRequest.UpdateUserRequest.FirstName} ${foundRequest.UpdateUserRequest.LastName} (${foundRequest.UpdateUserRequest.Email})
                </div>
            `;


            html = `
                ${titleStatusContainer}
                ${userInfoContainer}
                <div class="mt-2 description-block">
                    <p>${description}</p>
                    <p class="d-none text-danger error-msg px-0"></p>
                </div>
            `;
        }
        else {
            let titleStatusContainer = `
                <div class="d-flex justify-content-start align-items-center">
                    <div class="modal-title mb-0">${title}</div>
                </div>
            `

            html = `
                ${titleStatusContainer}
                <div class="mt-2 description-block">
                    <p>${description}</p>
                    <p class="d-none text-danger error-msg px-0"></p>
                </div>
            `
        }
        

        return html;
    }

    showLoading(isLoading: boolean) {
        this.addController.showLoading(isLoading);
    }

    showSaved(isSaved: boolean) {
        this.addController.showSaved(isSaved);
    }

    showErrorMessage(errorMsg: string) {
        let modalTarget = $(`#${this.modalIdTarget}`).find(".description-block");
        let errorMsgContainer = modalTarget.find(".error-msg");
        errorMsgContainer.text(errorMsg);
        errorMsgContainer.removeClass("d-none");
    }

    hideErrorMessage() {
        let errorMsgContainer = $(`#${this.modalIdTarget}`).find(".description-block").find(".error-msg");
        errorMsgContainer.addClass("d-none");
    }

    getUpdatedUser(): AppUserExtended {
        return this.addController.getCurrentItem()
    }

    validate(): boolean {
        return this.addController.validate();
    }
}